import React from 'react';

import styles from './styled-input.module.scss';
export const Help = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={className ? `${styles['help']} ${className}` : styles['help']} {...props} />
);

export const Error = ({ className, ...props }: React.ComponentPropsWithoutRef<'span'>) => (
  <span className={className ? `${styles['error']} ${className}` : styles['error']} {...props} />
);
